import { render, staticRenderFns } from "./IPGMemberCallback.vue?vue&type=template&id=2108b036&scoped=true"
import script from "./IPGMemberCallback.vue?vue&type=script&lang=js"
export * from "./IPGMemberCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108b036",
  null
  
)

export default component.exports